// Temporary buffs from eaten dishes. Stored as an array of active effects with
// expiration timestamps. `getStat` in save.js reads these for effective values.

import { getState, save } from './save.js';

export function getBuffs(){
  pruneBuffs();
  return getState().buffs || [];
}

export function pruneBuffs(){
  const now = Date.now();
  const state = getState();
  if (!state.buffs) state.buffs = [];
  const before = state.buffs.length;
  state.buffs = state.buffs.filter(b => b.expires > now);
  if (state.buffs.length !== before) save();
}

export function addBuff({ stat, amount, duration, source }){
  const state = getState();
  state.buffs = state.buffs || [];
  const now = Date.now();
  // stack same-stat/source buffs by extending duration and taking the larger bonus
  const existing = state.buffs.find(b => b.stat === stat && b.source === source);
  if (existing){
    existing.amount = Math.max(existing.amount, amount);
    existing.expires = Math.max(existing.expires, now + duration);
  } else {
    state.buffs.push({ stat, amount, expires: now + duration, source });
  }
  save();
}

// Total bonus for a given stat from active buffs.
export function buffBonus(stat){
  pruneBuffs();
  const state = getState();
  if (!state.buffs) return 0;
  return state.buffs.reduce((sum, b) => b.stat === stat ? sum + b.amount : sum, 0);
}

export function activeBuffSummary(){
  pruneBuffs();
  const state = getState();
  if (!state.buffs) return [];
  const now = Date.now();
  return state.buffs.map(b => ({
    stat: b.stat,
    amount: b.amount,
    remaining: Math.max(0, Math.ceil((b.expires - now) / 1000)),
    source: b.source
  }));
}
